// Global navigation loader state
let navigationLoaderCallback: ((show: boolean, path?: string) => void) | null = null;

export const setNavigationLoaderCallback = (
  callback: (show: boolean, path?: string) => void
) => {
  navigationLoaderCallback = callback;
};

export const showNavigationLoader = (path?: string) => {
  if (navigationLoaderCallback) {
    navigationLoaderCallback(true, path);
  }
};

export const hideNavigationLoader = () => {
  if (navigationLoaderCallback) {
    navigationLoaderCallback(false);
  }
};

